// Presentation only: AMP owns the popup, its fields, events and requests.
export function installRestockAppearance(root, stylesheetUrl) {
  if (!stylesheetUrl) return () => {};
  const attachedFrames = new Map();
  const sentenceCase = element => {
    if (element?.textContent.trim() === 'NOTIFY ME WHEN AVAILABLE') {
      element.textContent = 'Notify me when available';
    }
  };
  const styleFrame = frame => {
    try {
      const popupDocument = frame.contentDocument;
      if (!popupDocument?.head || !popupDocument.querySelector('#BISModal')) return;
      if (!popupDocument.getElementById('yl-restock-popup-styles')) {
        const link = popupDocument.createElement('link');
        link.id = 'yl-restock-popup-styles';
        link.rel = 'stylesheet';
        link.href = stylesheetUrl;
        popupDocument.head.append(link);
      }
      sentenceCase(popupDocument.getElementById('bis-modal-title'));
    } catch {
      // A future cross-origin popup keeps working with the provider's styles.
    }
  };
  const sync = () => {
    for (const [frame, onLoad] of attachedFrames) {
      if (frame.isConnected) continue;
      frame.removeEventListener('load', onLoad);
      attachedFrames.delete(frame);
    }
    sentenceCase(root.querySelector('.yl-product-form > #BIS_trigger'));
    const frame = root.getElementById('BIS_frame');
    if (!frame || frame.tagName !== 'IFRAME') return;
    if (!attachedFrames.has(frame)) {
      const onLoad = () => styleFrame(frame);
      attachedFrames.set(frame, onLoad);
      frame.addEventListener('load', onLoad);
    }
    styleFrame(frame);
  };
  const observer = new MutationObserver(sync);
  observer.observe(root.body, { childList: true, subtree: true });
  sync();
  return () => {
    observer.disconnect();
    for (const [frame, onLoad] of attachedFrames) frame.removeEventListener('load', onLoad);
    attachedFrames.clear();
  };
}

const loader = document.querySelector('script[data-yl-restock-appearance]');
if (loader) installRestockAppearance(document, loader.dataset.popupStylesheet);
